export const limitMaxLength = (e, value, maxLength) => {
    
    if (value.length > maxLength) {
        e.target.value = value.substring(0, maxLength);
    }
}

export default limitMaxLength;